module.exports = __webpack_public_path__ + "static/media/background-essay.9aa89c09.svg";